import axios from 'axios';
import httpClient from '../httpService';
import { BSKT_MonHoc, CreateOrEditMonHocDto } from './models/MonHocModels';
import { ExecuteResultDto } from '../base-model/ExecuteResultDto';

const MonHocApiUrl = '/api/MonHoc/';
function requireSuccess(res:any) {
    const result=res?.is_success!==undefined?res:res?.data;
    if(result?.is_success===false) throw Error(result.message||'Không thực hiện được thao tác môn học.');
    return result;
}

function unwrapMonHocArrayResponse(res: any): BSKT_MonHoc[] {
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.data)) return res.data;
    if (Array.isArray(res?.data?.data)) return res.data.data;
    if (Array.isArray(res?.data?.items)) return res.data.items;
    if (Array.isArray(res?.items)) return res.items;
    return [];
}

function unwrapMonHocItemResponse(res: any): BSKT_MonHoc | null {
    if (res && typeof res === 'object' && 'ID_mon' in res) return res as BSKT_MonHoc;
    if (res?.data && typeof res.data === 'object' && 'ID_mon' in res.data) return res.data as BSKT_MonHoc;
    if (res?.data?.data && typeof res.data.data === 'object' && 'ID_mon' in res.data.data) {
        return res.data.data as BSKT_MonHoc;
    }
    return null;
}

export const MonHocService = {
    getAll: async (strict=false): Promise<BSKT_MonHoc[]> => {
        const res = await httpClient.get(MonHocApiUrl + 'getAll');
        if(strict) requireSuccess(res);
        return unwrapMonHocArrayResponse(res);
    },
    selectById: async (id: number): Promise<BSKT_MonHoc> => {
        const res = await httpClient.get(MonHocApiUrl + 'selectById/' + id);
        return (
            unwrapMonHocItemResponse(res) ?? {
                ID_mon: 0,
                Ky_hieu: undefined,
                Ten_mon: undefined,
                So_tin_chi: 0,
                Ly_thuyet: 0,
                Thuc_hanh: 0
            }
        );
    },
    selectAll: async (): Promise<BSKT_MonHoc[]> => {
        var result = await httpClient.get(MonHocApiUrl + 'selectAll');
        return unwrapMonHocArrayResponse(result);
    },
    createOrEdit: async (model: CreateOrEditMonHocDto): Promise<ExecuteResultDto> => {
        console.log('MonHocService.createOrEdit', model);
        return await httpClient.post(MonHocApiUrl + 'CreateOrEdit', model).then((response) => {
            return response.data;
        });
    },

    delete: async (id: number) => {
        return await httpClient.delete(MonHocApiUrl + 'delete/' + id).then((response) => {
            const result=requireSuccess(response);
            if(result?.is_success!==true)throw Error('Máy chủ chưa xác nhận xóa môn học.');
            return result;
        });
    },
    insert: async (model: BSKT_MonHoc): Promise<BSKT_MonHoc> => {
        const response=await httpClient.post(MonHocApiUrl + 'insert', model);
        requireSuccess(response);
        const item=unwrapMonHocItemResponse(response);
        if(!item||item.ID_mon<=0)throw Error('Máy chủ chưa trả về môn học đã lưu.');
        return item;
    },
    update: async (model: BSKT_MonHoc): Promise<BSKT_MonHoc> => {
        const response=await httpClient.put(MonHocApiUrl + 'update/' + model.ID_mon, model);
        requireSuccess(response);
        const item=unwrapMonHocItemResponse(response);
        if(!item||item.ID_mon<=0)throw Error('Máy chủ chưa trả về môn học đã lưu.');
        return item;
    }
};
